import { render, staticRenderFns } from "./featurepack_new.vue?vue&type=template&id=1562f81e&scoped=true&"
import script from "./featurepack_new.vue?vue&type=script&lang=js&"
export * from "./featurepack_new.vue?vue&type=script&lang=js&"
import style0 from "./featurepack_new.vue?vue&type=style&index=0&id=1562f81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562f81e",
  null
  
)

export default component.exports